import moment from 'moment';
import apis from 'src/const/apis';
import request from 'src/utils/request';
import { EnumLifetimeType } from 'src/const/date';
import { MATERIAL_TYPE } from 'src/const/state/ad';
import { SORT_ORDER } from 'src/const/statistics/metrics-emun';
import { EnumImageInfo } from 'src/const/statistics/basic-base-info';
import { TIME_FORMAT } from 'src/utils/dateUtil';


const defaultBaseInfoKey = EnumImageInfo.map(item => item.key);
const today = moment().format(TIME_FORMAT);
const stday = moment().add(-7, 'd').format(TIME_FORMAT);

const defaultImageStatKeys = [
  'stat_cost',
  'cpc',
  'cpm',
  'show_cnt',
  'click_cnt',
  'ctr',
];

export default {
  namespaced: true,

  state: {
    loading: false, // 表格 loading
    list: [],
    selectedKeys: [...defaultImageStatKeys],
    currentCustomKey: 'default',
    defaultColKeys: defaultImageStatKeys,

    sortState: 'create_time',
    sortOrder: SORT_ORDER.DECENT,
    pagination: {
      limit: 20,
      page: 1,
      page_count: 1,
    },

    lifeTime: EnumLifetimeType.unchosen,
    st: stday,
    et: today,
    filterOptions: {
      keyword: '',
      country: [],
      image_mode: [],
      placement_id: [],
      cost: {
        cost_lower: 0,
        cost_upper: 0,
      },
    },
  },

  mutations: {
    changeLoading(state, data) {
      state.loading = data;
    },
    changeList(state, data) {
      state.list = data;
    },
    changeCustom(state, data) {
      state.selectedKeys = data;
    },
    changeSortData(state, data) {
      // 默认 create_time 降序
      if (!data || !data.sortState) {
        state.sortState = 'create_time';
        state.sortOrder = SORT_ORDER.DECENT;
        return;
      }
      state.sortState = data.sortState;
      state.sortOrder = data.sortOrder;
    },
    switchCustom(state, data) {
      const { key, columns } = data;
      state.currentCustomKey = key;
      if (columns) {
        state.selectedKeys = columns;
      }
    },
    changePagination(state, data) {
      state.pagination = {
        ...state.pagination,
        ...data,
      };
    },
    changeDate(state, data) {
      state.lifeTime = data.lifeTime;
      state.st = data.st;
      state.et = data.et;
    },
    changeFilterOptions(state, data) {
      state.filterOptions = {
        ...state.filterOptions,
        ...data,
      };
    },
  },

  getters: {
    requestData(state) {
      const metrics = state.selectedKeys.filter(item => !defaultBaseInfoKey.includes(item));

      return {
        m_type: MATERIAL_TYPE.IMAGE,
        metrics,
        is_lifetime: state.lifeTime,
        st: state.st,
        et: state.et,
        order_field: state.sortState,
        order_type: state.sortOrder,
        page: state.pagination.page,
        page_size: state.pagination.limit,
        keyword: state.filterOptions.keyword,
        country: state.filterOptions.country,
        image_mode: state.filterOptions.image_mode,
        placement_id: state.filterOptions.placement_id,
        cost_lower: !state.filterOptions.cost.cost_lower ? '' : String(state.filterOptions.cost.cost_lower),
        cost_upper: !state.filterOptions.cost.cost_upper ? '' : String(state.filterOptions.cost.cost_upper),
      };
    },
  },

  actions: {
    // 获取列表数据
    getImageList({ commit, state, getters }, data) {
      const { requestData } = getters;

      commit('changeLoading', true);
      return request.post(apis.library.material_list, requestData)
        .then(({ data }) => {
          const list = data.material_infos.map(item => ({
            ...item.base_info,
            ...item.metrics,
            id: item.base_info.material_id, // 用于列表选择操作
          }));
          const pagination = {
            limit: data.page_size || 20,
            page: data.page || 1,
            page_count: Math.ceil(data.total / data.page_size) || 1,
          };

          commit('changeList', list);
          commit('changePagination', pagination);
          commit('changeLoading', false);
        })
        .catch((e) => {
          commit('changeLoading', false);
        });
    },
  },
};
